import {
  PatchApiSpoModelsBody,
  PostApiSpoModelsBody,
  SpoModelsResponse,
  SpoModelsUpdateResponse,
} from '@spo/types';
import { apiBff } from '.';

export const getModels = async (
  postApiSpoModelsBody: PostApiSpoModelsBody,
): Promise<SpoModelsResponse> => {
  return apiBff.callBFF('POST', 'spo/models', postApiSpoModelsBody);
};

export const updateModels = async (
  patchApiSpoModelsBody: PatchApiSpoModelsBody,
): Promise<SpoModelsUpdateResponse> => {
  return apiBff.callBFF('PATCH', 'spo/models', patchApiSpoModelsBody);
};
